import { Callout } from '@/_shared/components/ui/callout';
import { cn } from '@/_shared/lib/utils';

/** The error of a sign-in that returned to this page. */
export function SignInErrorCallout({
  message,
  className,
}: {
  message: string;
  className?: string;
}): React.ReactElement {
  return (
    <Callout variant="error" role="alert" className={cn('text-left', className)}>
      <p>{message}</p>
    </Callout>
  );
}
